

class    PageTitle  {

    constructor( ) {
        this.title="";
        this.callBacks = [];
    }

    setTitle(txt){
        this.title=txt;
        if(this.callBacks.length>0){
            for (let i = 0; i < this.callBacks.length; i++) {
                let fun=this.callBacks[i];
                fun();
            }
        }
    }

    addCallBacks(fun){
        this.callBacks.push(fun);
    }

}

export default PageTitle;
